import { Tag, Tooltip } from '@nimbus-ds/components';
import { ExclamationCircleIcon } from '@nimbus-ds/icons';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { ICON_MAP, ICON_SIZE, STATUS_MAP } from './util';

interface TransferDetailStatusProps {
  status: ProductTransferListResponseDto[number]['status'];
  isPartial: boolean;
}

function TransferDetailStatus({
  status,
  isPartial,
}: Readonly<TransferDetailStatusProps>) {
  const t = useTranslationCatalog('transfers.list');

  const getIcon = () => {
    if (status === 'ready' && isPartial) {
      return <ExclamationCircleIcon size={ICON_SIZE} />;
    }
    return ICON_MAP[status];
  };

  const getTooltipContent = () => {
    if (status === 'ready' && isPartial) {
      return t('status.partial');
    }
    return t(`status.${status}`);
  };

  return (
    <Tooltip content={getTooltipContent()} position="top">
      <Tag appearance={STATUS_MAP[status]}> {getIcon()}</Tag>
    </Tooltip>
  );
}

export default TransferDetailStatus;
